import React, {useState} from 'react';
import {useTranslation} from "react-i18next";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTelegram} from "@fortawesome/free-brands-svg-icons";
import cl from '../../NotificationForm/NotificationForm.module.css';
import {INotificationGetAction} from "../../../../../../../app/interfaces/notification/INotificationGetAction";
import QRCode from "react-qr-code";
import UnsubscribeNotificationsDialog from "../../../actions/UnsubscribeNotifications/UnsubscribeNotificationsDialog";
import {IconProp} from "@fortawesome/fontawesome-svg-core";

type TelegramSubscriptionGuideSectionProps = {
    model: INotificationGetAction;
    reloadForm: () => Promise<void>;
};

const TelegramSubscriptionGuideSection: React.FC<TelegramSubscriptionGuideSectionProps> = ({
                                                                                               model,
                                                                                               reloadForm
                                                                                           }) => {
    const {t} = useTranslation();

    const [isUnsubscribeDialogShown, setIsUnsubscribeDialogShown] = useState<boolean>(false);

    return (
        <>
            <UnsubscribeNotificationsDialog onUnsubscribe={() => reloadForm()}
                                            type={'Telegram'}
                                            show={isUnsubscribeDialogShown}
                                            setShow={setIsUnsubscribeDialogShown}/>

            <div>
                <div className={'default-form-collapse-header'}>
                    <div className={cl.collapse}>
                        <div>
                            <div className={cl.tg}>
                                <FontAwesomeIcon icon={faTelegram as IconProp}/>
                            </div>
                            <div>
                                {t("notification.labels.telegram")}
                            </div>
                        </div>
                        <div>
                            {model.hasTelegram &&
                                <button type={'button'}
                                        className={cl.button}
                                        onClick={() => setIsUnsubscribeDialogShown(prev => !prev)}>
                                    {t("notification.btn.unsubscribe")}
                                </button>
                            }
                        </div>
                    </div>
                </div>

                <div style={{padding: '5px 5px 0 5px'}}>
                    <div className={`mgb-10 mgt-10 ${cl.qr}`}>
                        <div>
                            <QRCode
                                size={256}
                                style={{height: "auto", maxWidth: "100%", width: "100%"}}
                                value={model.telegramLink}
                                viewBox={`0 0 256 256`}
                            />
                        </div>
                    </div>

                    <p className={cl.paragraph}>
                        {t("notification.labels.telegram-guide-main-label")}
                    </p>

                    <p className={cl.paragraph}>
                        {`1. ${t("notification.labels.telegram-guide-step-1")}`}
                    </p>

                    <p className={cl.paragraph}>
                        {`${t("notification.labels.telegram-guide-step-1-1")} `}
                        <a target={'_blank'}
                           className={cl.link}
                           href={model.telegramLink}>
                            {model.telegramBotName}
                        </a>
                        {` ${t("notification.labels.telegram-guide-step-1-2")}`}
                    </p>

                    <p className={cl.paragraph}>
                        {`${t("notification.labels.telegram-guide-step-1-3").replace('{0}', model.telegramBotName)}`}
                    </p>

                    <p className={cl.paragraph}>
                        {`2. ${t("notification.labels.telegram-guide-step-2")}`}
                    </p>

                    <p className={cl.paragraph}>
                        {`3. ${t("notification.labels.telegram-guide-step-3")}`}
                    </p>
                </div>
            </div>
        </>
    );
};

export default TelegramSubscriptionGuideSection;
